import { ReactNode, useLayoutEffect } from "react";
import { createFastContext } from "../../contexts/createFastContext";
import { MAP_ELEMENT } from "../../contexts/WorldMapContext/constants";
import { BarentsWatchService } from "../../util/barentswatch/api";
import { showErrorResponse } from "../../util/varibles/global";
import { IPoint, IPosition, IProductionArea } from "../../util/varibles/interface";
import { SOCKET_FUNC, SOCKET_NAME } from "../../web-socket/constants";
import WSService from "../../web-socket/web-socket-service";

interface IState {
    locations: {
        id: string
        type: MAP_ELEMENT
        position?: IPosition
        name: string
    }[]
    points: IPoint[]
    requestId: string
    loading: boolean
    onlySeaway: boolean
    proAreas: {
        loading: boolean,
        data: IProductionArea[]
    }
}

const {
    Provider,
    useStore: useRouteUpgrade,
    setStore: setRouteUpgrade,
    getStore: getRouteUpgrade,
    callEvent: callEventRouteUpgrade
} = createFastContext<IState>({
    points: [],
    proAreas: { loading: false, data: [] },
    requestId: '-',
    loading: false,
    onlySeaway: true,
    locations: []
});

const InitPage = () => {
    const get = getRouteUpgrade();
    const set = setRouteUpgrade();
    useLayoutEffect(() => {
        new WSService({
            groups: ['auto-route'],
            listener: {
                lev: SOCKET_NAME.PAGE,
                func: (value: any) => {
                    switch (value.function) {
                        case SOCKET_FUNC.MULTI_AUTO_ROUTE: {
                            const { requestId } = get();
                            if (value.request_id === requestId) {
                                if (value.status === 200) {
                                    const { path, node_ids = [] } = value;
                                    set(({ locations }) => {
                                        const state: Partial<IState> = {
                                            loading: false,
                                            points: path,
                                            requestId: "-"
                                        };
                                        if (node_ids.length > 0) {
                                            state.locations = node_ids.map((key: string) => {
                                                return locations.find(item => item.id === key);
                                            })
                                        }
                                        return state
                                    });
                                    return;
                                } else {
                                    showErrorResponse('Auto route failure', value.message);
                                }
                                set({ loading: false, requestId: '-' })
                            }
                            break;
                        }
                        default:
                            return;
                    }
                }
            }
        });
        set({ proAreas: { loading: true, data: [] } })
        BarentsWatchService.getProductionAreas()
            .then(rs => {
                set({ proAreas: { loading: false, data: rs } })
            })
            .catch(error => {
                showErrorResponse(error, 'Get production area failed');
                set({ proAreas: { loading: false, data: [] } })
            });

        return () => {
            WSService.close(SOCKET_NAME.PAGE, ['auto-route']);
        }
    }, [set, get]);
    return null
}

const RouteUpgradeProvider = ({ children, ...args }: { children: ReactNode } & Partial<IState>) => {
    return <Provider props={{ ...args }}>
        <InitPage />
        {children}
    </Provider>
}


export { callEventRouteUpgrade, getRouteUpgrade, RouteUpgradeProvider, setRouteUpgrade, useRouteUpgrade };

